import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { RuleWizard } from 'page-components/auto-ticket-rules'

export const AutoTicketRulesCreateScreen = () => {
    const { templateId } = useParams()
    const location = useLocation()
    const templateName = location.state?.templateName

    return (
        <RuleWizard templateId={templateId} templateName={templateName} />
    )
}

export const AutoTicketRulesEditScreen = () => {
    const { templateId, ruleId } = useParams()
    const location = useLocation()
    const templateName = location.state?.templateName

    return (
        <RuleWizard
            templateId={templateId}
            ruleId={ruleId}
            templateName={templateName}
        />
    )
}
